import adapter from '../adapter-forum-post';
import { siteIDs } from '../../../adapters/utils';
var IDs = adapter.IDs, SchemaTypes = adapter.SchemaTypes;
export default {
    type: SchemaTypes.FORUM_POST,
    schema: {
        '@context': 'https://schema.org/',
        '@type': 'DiscussionForumPosting',
        headline: "{{" + IDs.HEADLINE + "}}",
        mainEntityOfPage: {
            '@id': "{{" + IDs.POST_PAGE_URL + "}}",
            '@type': 'itemPage',
            url: "{{" + IDs.POST_PAGE_URL + "}}",
        },
        articleBody: "{{" + IDs.CONTENT_FULL + "}}",
        articleSection: "{{" + IDs.CATEGORY_NAME + "}}",
        author: {
            '@type': 'Person',
            name: "{{" + IDs.AUTHOR + "}}",
            sameAs: "{{" + IDs.AUTHOR_PROFILE_URL + "}}",
        },
        datePublished: "{{" + IDs.PUBLISH_DATE + "}}",
        dateModified: "{{" + IDs.LAST_MODIFIED_DATE + "}}",
        image: {
            '@type': 'ImageObject',
            height: "{{" + IDs.COVER_IMAGE_HEIGHT + "}}",
            width: "{{" + IDs.COVER_IMAGE_WIDTH + "}}",
            contentUrl: "{{" + IDs.COVER_IMAGE + "}}",
            url: "{{" + IDs.POST_PAGE_URL + "}}",
            representativeOfPage: true,
        },
        video: "{{" + IDs.VIDEO + "}}",
        interactionStatistic: {
            '@type': 'InteractionCounter',
            interactionType: 'https://schema.org/ReplyAction',
            userInteractionCount: "{{" + IDs.COMMENT_AMOUNT + "}}",
        },
        publisher: {
            '@type': 'Organization',
            name: "{{" + siteIDs.BUSINESS_NAME + "}}",
            sameAs: "{{" + siteIDs.SITE_URL + "}}",
            logo: {
                '@type': 'ImageObject',
                url: "{{" + siteIDs.BUSINESS_LOGO + "}}",
            },
        },
    },
};
